












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Editor from '@tinymce/tinymce-vue'
import GroupService from '@/services/GroupService'
import { ETinyFileType } from '@/models'
import { checkScript } from '@/validations/validation'
import updateGroupMaxFileSize from '@/helpers/UpdateGroupMaxFileSize'
//@ts-ignore
import _, { DebouncedFunc } from 'lodash'
import MentionSuggestDropdown from '@/components/MentionSuggestDropdown.vue'
import {
  allItemMention,
  allMentionCheckKeyword,
  calculateMentionPopup,
  releaseMentionPopup,
  handleDeleteSuggestion,
  handleInputToMention,
  handleSelectSuggestion
} from '@/helpers/Mentions'
import { ERR_API_KEY } from '@/constants'
import { removeHTML } from '@/helpers/Common'
import {
  EDITOR_VIDEO_ACCEPT,
  EDITOR_VIDEO_KIND,
  isEditorVideo,
  isWithinVideoMaxSize
} from '@/helpers/EditorVideo'

@Component({ components: { Editor, MentionSuggestDropdown } })
export default class TextEditor extends Vue {
  //prop
  @Prop() startData?: string
  @Prop() tinyFileType!: ETinyFileType
  @Prop() maxFileSizeProps?: any

  //data
  private isCommonTopic = !this.$route.params.groupId
  private fileIds: number[] = []
  editorData: string = ''

  //config tiny editor
  getTinyConfig: any = {}
  private getKey: string = ''

  //validate
  @Prop() checkEmpty?: boolean
  @Prop() emptyContent?: boolean
  @Prop() overLengthContent?: boolean
  @Prop() includesScriptTagContent?: boolean
  @Prop() allowMention?: boolean
  @Prop() fetchMention?: (keyword: string) => Promise<any>;
  isEmpty: boolean = false
  isOverLength: boolean = false
  isIncludesScriptTag: boolean = false

  private imageType: string[] = [
    'image/png',
    'image/gif',
    'image/jpeg',
    'image/jpg'
  ]
  requiredMess: string = this.$t('common.form.needed_item', {
    name: this.$t('common.form.document') as string
  }) as string
  overLengthMess: string = this.$t('common.form.max_length', {
    name: this.$t('common.form.document') as string,
    length: 20000
  }) as string
  includesScriptTagMess: string = this.$t('common.form.no_script_tag', {
    name: this.$t('common.form.document') as string
  }) as string
  private maxFileSize: any = {
    mb: this.isCommonTopic
      ? 25
      : Number(this.$store.state.userInfo.user.current_group_max_file_size),
    bytes: this.isCommonTopic
      ? 25 * 1048576
      : Number(this.$store.state.userInfo.user.current_group_max_file_size) *
        1048576
  }

  //modal helper
  modalMess: string = ''
  randomId: number = Math.random()

  // editor mentions
  suggestionList: any[] = []
  showSuggestion: boolean = false
  private editorInstance: any
  private debouncedFetchMention: DebouncedFunc<(event: any) => void>
  private preventFetchMention = false
  private isMentioning = false
  private currentInput = ''
  isLoading = false
  private failKeyword = ''
  private lastKeyword = ''
  private isComposition = false

  created() {
    this.init()
    this.handleMaxFileSize()
    document.body.classList.add('tiny-z1')
    this.debouncedFetchMention = _.debounce(
      this.onRetriveMentionListFromParent,
      500
    )
  }

  onOpenSuggestionPopup(rect: any) {
    const mentionDropdownWrapper = this.$refs.mentionDropdownWrapper as Vue
    const suggestionDiv = mentionDropdownWrapper.$el as HTMLElement

    calculateMentionPopup({
      getRect: () =>
        this.editorInstance.selection.getRng().getBoundingClientRect(),
      suggestionDiv,
      callback: () => {
        this.showSuggestion = true
      },
      editorIframe: this.editorInstance.iframeElement
    })
  }

  onSelect({ event, suggestion }: any) {
    event.stopPropagation()
    this.isMentioning = true
    handleSelectSuggestion({
      suggestion,
      editorInstance: this.editorInstance,
      callback: () => {
        this.onClearSuggestionState()
      }
    })
  }

  onDelete(event: any) {
    handleDeleteSuggestion({
      event,
      editorInstance: this.editorInstance,
      callback: () => {
        this.onClearSuggestionState()
      }
    })
  }

  onClearSuggestionState() {
    // NWS-1773: 候補を閉じるタイミングで監視を解放する（積み上がりを防ぐ）
    releaseMentionPopup()
    this.suggestionList = []
    this.showSuggestion = false
    const mentionDropdownWrapper = this.$refs.mentionDropdownWrapper as Vue
    if (mentionDropdownWrapper && mentionDropdownWrapper.$el) {
      mentionDropdownWrapper.$el.scrollTop = 0
    }
  }

  async onRetriveMentionListFromParent(keyword: string) {
    const isDeleting = keyword.length < this.lastKeyword.length

    if (isDeleting) {
      this.failKeyword = ''
    }

    if (this.failKeyword && keyword.startsWith(this.failKeyword)) {
      return
    }

    const range = this.editorInstance.selection.getRng()
    const rect = range.getBoundingClientRect()

    this.suggestionList = []
    this.isLoading = true
    this.onOpenSuggestionPopup(rect)
    const startTime = Date.now()

    const response = await this.fetchMention?.(keyword)

    const elapsed = Date.now() - startTime
    const delay = Math.max(0, 500 - elapsed)

    setTimeout(() => {
      this.isLoading = false
      this.lastKeyword = keyword
      if (response && response.length > 0) {
        this.failKeyword = ''
        this.suggestionList = response
      } else {
        this.failKeyword = keyword
      }

      // handle all mention
      if (!keyword || allMentionCheckKeyword.includes(keyword.toLowerCase())) {
        this.suggestionList.unshift(allItemMention)
      }

      if (!this.suggestionList.length) {
        this.onClearSuggestionState()
      }
    }, delay)
  }

  destroyed() {
    // NWS-1773: 画面破棄時にも取り残しが無いようにする
    releaseMentionPopup()
    document.body.classList.remove('tiny-z1')
  }

  async handleMaxFileSize() {
    if (this.maxFileSizeProps) {
      this.maxFileSize = this.maxFileSizeProps
    } else {
      await updateGroupMaxFileSize(this.$route.params.groupId)
      this.maxFileSize = {
        mb: this.isCommonTopic
          ? 25
          : Number(this.$store.state.userInfo.user.current_group_max_file_size),
        bytes: this.isCommonTopic
          ? 25 * 1048576
          : Number(
              this.$store.state.userInfo.user.current_group_max_file_size
            ) * 1048576
      }
    }
  }

  /**
   * init for TinyMCE
   */
  init() {
    this.getKey = process.env.VUE_APP_TINY_MCE_API_KEY as string

    this.getTinyConfig = {
      language: this.$store.state.setting.setting.setting_language.code,
      height: 400,
      setup: (editor: any) => {
        this.editorInstance = editor
        this.$emit('getEditorInstance', editor)
        editor.ui.registry.addContextToolbar('textselection', {
          predicate: (node: any) => {
            return !editor.selection.isCollapsed()
          },
          items: 'bold italic | quicklink h1 h2 h3 blockquote',
          position: 'selection',
          scope: 'node'
        })
        editor.on('keydown', (e: any) => {
          if (this.allowMention) {
            if (e.key === 'Backspace') {
              this.onDelete(e)
            }

            if (e.key === 'Escape') {
              this.preventFetchMention = true
              this.onClearSuggestionState()
            }
          }
        })
        editor.on('compositionstart', () => {
          this.isComposition = true
        })
        editor.on('compositionend', () => {
          this.isComposition = false
          this.handleMentionInput()
        })
        editor.on('keyup', (e: any) => {
          if (!this.allowMention || this.isComposition) return

          this.handleMentionInput()
        })
        editor.on('blur', () => {
          this.failKeyword = ''
          setTimeout(() => {
            if (this.allowMention && !this.isMentioning) {
              this.onClearSuggestionState()
            }
          }, 100)
        })
        editor.on('click', (event: any) => {
          if (this.allowMention) {
            const target = event.target as HTMLElement
            const mentionDropdownWrapper = this.$refs
              .mentionDropdownWrapper as Vue
            const suggestionDropdown = mentionDropdownWrapper.$el as HTMLElement

            if (suggestionDropdown && !suggestionDropdown.contains(target)) {
              this.onClearSuggestionState()
            }
          }
        })
        editor.on('focusin', () => {
          if (!this.allowMention) return

          requestAnimationFrame(() => {
            handleInputToMention({
              editorInstance: editor,
              errorCallback: () => {
                this.debouncedFetchMention.cancel()
                this.onClearSuggestionState()
              },
              successCallback: (keyword: string) => {
                this.currentInput = keyword
                this.debouncedFetchMention(keyword)
              }
            })
          })
        })
      },
      selector: 'textarea#full-featured',
      formats: {
        blockquote: {
          block: 'blockquote',
          classes: 'tiny-editor-blockquote'
        }
      },
      content_style: `
        p, h1, h2, h3, h4, h5, h6, blockquote, ul, ol {
          margin: 0;
        }
        code {
          background-color: #FAFAFA !important;
          padding: 8px !important;
          color: #0D47A1 !important;
        }
      `,
      deprecation_warnings: false,
      nonbreaking_force_tab: true,
      toolbar_mode: 'wrap',
      menubar: true,
      entity_encoding: 'raw',
      plugins: [
        'advlist emoticons hr image media link lists nonbreaking preview searchreplace table blockquote'
      ],
      toolbar: [
        'fontsizeselect | fontselect | formatselect | undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | emoticons preview | image media link | searchreplace hr nonbreaking | table | blockquote'
      ],
      contextmenu: false,
      quickbars_insert_toolbar: false,
      default_link_target: '_blank',
      image_dimensions: false,
      font_formats: `
        Andale Mono=andale mono,monospace;
        Arial=arial,helvetica,sans-serif;
        Arial Black=arial black,sans-serif;
        Book Antiqua=book antiqua,palatino,serif;
        Comic Sans MS=comic sans ms,sans-serif;
        Courier New=courier new,courier,monospace;
        Georgia=georgia,palatino,serif;
        Helvetica=helvetica,arial,sans-serif;
        Impact=impact,sans-serif;
        Symbol=symbol;
        Tahoma=tahoma,arial,helvetica,sans-serif;
        Terminal=terminal,monaco,monospace;
        Times New Roman=times new roman,times,serif;
        Trebuchet MS=trebuchet ms,geneva,sans-serif;
        Verdana=verdana,geneva,sans-serif
      `,
      file_picker_callback: (callback: any, value: any, meta: any) => {
        // NWS-1962: 「メディアの挿入」のファイルボタンは動画（mp4・mov）を選んで上げる。画像の挿入は従来どおり
        if (meta && meta.filetype === 'media') {
          this.pickEditorVideo(callback)
          return
        }
        var input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')

        document.body.appendChild(input)

        input.onchange = (event: any) => {
          const files: File[] = event.target.files || event.dataTransfer.files
          if (!files.length) return
          if (
            files[0].size < this.maxFileSize.bytes &&
            this.imageType.includes(files[0].type)
          ) {
            let formData = new FormData()
            formData.set('file', files[0], files[0].name)
            formData.set('type', String(this.tinyFileType))
            if (this.$route.params.groupId) {
              formData.set('group_id', this.$route.params.groupId)
            }
            this.$blockui.show()
            GroupService.uploadFileTiny(formData)
              .then(res => {
                if (res.status === 200) {
                  callback(res.data.image_path, { title: files[0].name })
                  // if (res.data.file_id) {
                  //   this.fileIds.push(res.data.file_id)
                  // }
                }
              })
              .catch(err => {
                if (
                  err.response.data.message === ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY
                ) {
                  this.modalMess = this.$t(
                    'common.message.group_over_size'
                  ) as string
                  this.$bvModal.show(`modal-error-text-editor-${this.randomId}`)
                }
                //@ts-ignore
                tinymce.activeEditor.undoManager.undo()
              })
              .finally(() => this.$blockui.hide())
          } else {
            this.modalMess = this.$t('common.form.img_modified_with_max', {
              max: this.maxFileSize.mb
            }) as string
            this.$bvModal.show(`modal-info-text-editor-${this.randomId}`)
          }
          document.body.removeChild(input)
        }
        input.click()
      },
      images_upload_handler: (blobInfo: any, success: any, failure: any) => {
        if (
          blobInfo.blob().size < this.maxFileSize.bytes &&
          this.imageType.includes(blobInfo.blob().type)
        ) {
          let formData = new FormData()
          formData.set('file', blobInfo.blob(), blobInfo.blob().name)
          formData.set('type', String(this.tinyFileType))
          if (this.$route.params.groupId) {
            formData.set('group_id', this.$route.params.groupId)
          }
          this.$blockui.show()
          GroupService.uploadFileTiny(formData)
            .then(res => {
              if (res.status === 200) {
                success(res.data.image_path)
                // if (res.data.file_id) {
                //   this.fileIds.push(res.data.file_id)
                // }
              }
            })
            .catch(err => {
              if (
                err.response.data.message === ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY
              ) {
                this.modalMess = this.$t(
                  'common.message.group_over_size'
                ) as string
                this.$bvModal.show(`modal-error-text-editor-${this.randomId}`)
                //@ts-ignore
                tinymce.activeEditor.undoManager.undo()
              }
            })
            .finally(() => this.$blockui.hide())
        } else {
          this.modalMess = this.$t('common.form.img_modified_with_max', {
            max: this.maxFileSize.mb
          }) as string
          this.$bvModal.show(`modal-info-text-editor-${this.randomId}`)
          //@ts-ignore
          tinymce.activeEditor.undoManager.undo()
        }
      }
    }
  }

  /**
   * NWS-1962: 「メディアの挿入」で動画（mp4・mov）を選び、縮小せずに上げて動画の枠に入れる。
   * 上限はグループ設定の「1 ファイルあたりの上限」（会社からのお知らせは 25MB）。グループの容量に数えるかは別課題。
   */
  pickEditorVideo(callback: any) {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', EDITOR_VIDEO_ACCEPT)
    input.style.display = 'none'
    document.body.appendChild(input)

    input.onchange = (event: any) => {
      const files: File[] = event.target.files || event.dataTransfer.files
      if (input.parentNode) input.parentNode.removeChild(input)
      if (!files || !files.length) return
      const file = files[0]
      if (
        !isEditorVideo(file) ||
        !isWithinVideoMaxSize(file, this.maxFileSize.bytes)
      ) {
        this.modalMess = this.$t('common.form.video_modified_with_max', {
          max: this.maxFileSize.mb
        }) as string
        this.$bvModal.show(`modal-info-text-editor-${this.randomId}`)
        return
      }

      const formData = new FormData()
      formData.set('file', file, file.name)
      formData.set('type', String(this.tinyFileType))
      formData.set('kind', EDITOR_VIDEO_KIND)
      if (this.$route.params.groupId) {
        formData.set('group_id', this.$route.params.groupId)
      }
      this.$blockui.show()
      GroupService.uploadFileTiny(formData)
        .then(res => {
          if (res.status === 200 && res.data.image_path) {
            callback(res.data.image_path)
          }
        })
        .catch(err => {
          const message = err?.response?.data?.message
          if (message === ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY) {
            this.modalMess = this.$t('common.message.group_over_size') as string
          } else if (typeof message === 'string' && /[^\x00-\x7F]/.test(message)) {
            // サーバーが日本語の文言（上限の MB 入り。NWS-1984 と同じ形）で断ったときはそのまま出す
            this.modalMess = message
          } else {
            // 形式・大きさ（サーバーの受け取り上限を含む）で断られたとき
            this.modalMess = this.$t('common.form.video_upload_failed', {
              max: this.maxFileSize.mb
            }) as string
          }
          this.$bvModal.show(`modal-error-text-editor-${this.randomId}`)
        })
        .finally(() => this.$blockui.hide())
    }
    input.click()
  }

  handleMentionInput() {
    if (this.preventFetchMention) {
      this.preventFetchMention = false
      return
    }

    this.showSuggestion = false

    handleInputToMention({
      editorInstance: this.editorInstance,
      errorCallback: () => {
        this.debouncedFetchMention.cancel()
        this.onClearSuggestionState()
      },
      successCallback: (keyword: string) => {
        this.currentInput = keyword
        this.debouncedFetchMention(keyword)
      }
    })
  }

  /**
   * Set default data for input
   */
  @Watch('startData')
  setStartData() {
    this.editorData = this.startData ? this.startData : ''
  }

  /**
   * Watching input
   */
  @Watch('editorData')
  getData() {
    const text = removeHTML(this.editorData)
    this.$emit('getData', {
      html: this.editorData,
      text,
      fileIds: this.fileIds
    })
    if (this.checkEmpty) {
      this.isEmpty = !this.checkPTagInner() && !text.trim()
    }
    this.isOverLength =
      new Blob([text]).size > 80000 || _.toArray(text).length > 20000
    this.isIncludesScriptTag = checkScript(text)
  }

  /**
   * Trigger error when user passing emptyContent = true
   */
  @Watch('emptyContent')
  triggerEmptyError() {
    this.isEmpty = !!(this.emptyContent && this.checkEmpty)
  }

  /**
   * Trigger error when user passing overLengthContent = true
   */
  @Watch('overLengthContent')
  triggerOverLengthError() {
    if (this.overLengthContent) {
      this.isOverLength = true
    }
  }

  /**
   * Trigger error when user passing overLengthContent = true
   */
  @Watch('includesScriptTagContent')
  triggerIncludesScriptTagError() {
    if (this.includesScriptTagContent) {
      this.isIncludesScriptTag = true
    }
  }

  /**
   * Use to reset validation editor after upload file
   */
  resetIsEmpty() {
    this.isEmpty = false
  }

  /**
   * Check that DOM inner text have another tag
   */
  checkPTagInner() {
    let tmp = document.createElement('DIV')
    tmp.innerHTML = this.editorData
    const elmnt = tmp.getElementsByTagName('p')
    let innerTextofP = ''
    for (let index = 0; index < elmnt.length; index++) {
      const el = elmnt[index]
      innerTextofP = innerTextofP + el.innerHTML
      if (el.innerHTML.includes('<')) break
    }
    return innerTextofP.includes('<')
  }
}
